import type { DistanceType } from '../types';

const DISTANCE_DISPLAY: Record<DistanceType, string> = {
  '5K': '5K',
  '10K': '10K',
  '32K': '32K',
  half: '21.1K',
  full: '42.2K',
  ultra: 'ULTRA',
  trail: 'TRAIL',
  other: 'OTHER',
};

export function formatDistance(distance: DistanceType): string {
  return DISTANCE_DISPLAY[distance] ?? distance.toUpperCase();
}

const DISTANCE_ORDER: DistanceType[] = ['5K', '10K', 'half', '32K', 'full', 'ultra', 'trail', 'other'];
const DISTANCE_RANK: Record<DistanceType, number> = Object.fromEntries(
  DISTANCE_ORDER.map((d, i) => [d, i]),
) as Record<DistanceType, number>;

export function sortDistances(distances: DistanceType[]): DistanceType[] {
  return [...distances].sort((a, b) => DISTANCE_RANK[a] - DISTANCE_RANK[b]);
}
